function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "92jc9z2hsb",
  x1: "62.869%",
  x2: "14.195%",
  y1: "30.195%",
  y2: "99.191%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#279DE1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#7CE9C4"
})), /*#__PURE__*/React.createElement("path", {
  id: "hdzar3m96a",
  d: "M9.706 13.235V15H3.088v-1.765h6.618zM7.5 10.147v2.647H5.294v-2.647H7.5zM10.588 0v5.294c0 2.437-1.876 4.412-4.19 4.412-2.316 0-4.192-1.975-4.192-4.412V0h8.382zM1.765 1.324v3.97C.79 5.294 0 4.504 0 3.53V1.324h1.765zm11.03 0v2.205c0 .975-.791 1.765-1.766 1.765v-3.97h1.765z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-32 -874) translate(0 843) translate(32 31) translate(.882)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mb64y2j87c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#hdzar3m96a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "url(#92jc9z2hsb)",
  xlinkHref: "#hdzar3m96a"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mb64y2j87c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0D6AB7",
  d: "M10.588 9.671V6.142C8.764 5.442 6.063 3.8 5.87 0 3.804.273 2.206 2.129 2.206 4.377v3.88L3.549 9.67h7.04z",
  transform: "rotate(-180 6.397 4.836)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#164A7D",
  d: "M6.013 13.235h3.693V15h-5.13c.73-.71 1.208-1.298 1.437-1.765zM6.937 10.147H7.5v2.647H6.245c.418-.944.649-1.827.692-2.647z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0D6AB7",
  d: "M0 1.324h1.765v2.095C1.11 3.272.523 3.2 0 3.206V1.324z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0D6AB7",
  d: "M11.03 1.999v3.295c.624 0 1.173-.324 1.486-.814C12.145 3.534 11.03 1.877 11.03 2z",
  opacity: 0.22
})))))));

function SvgTrophy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.0f53ef0c.svg";
export { ForwardRef as ReactComponent };